import { ROUTES } from '@/constants/routes'
import { githubCopy } from '@/copy'
import { useWorkspaceStore } from '@/store/workspace'
import { Alert } from '@/ui/Alert/Alert'
import { Link } from '@/ui/Link/Link'
import { Spinner } from '@/ui/Loading/Loading'
import { Inline } from '@/ui/layout/Inline'
import { Stack } from '@/ui/layout/Stack'
import { Text } from '@/ui/layout/Text'
import { WsPageShell } from './WsPageShell'

/**
 * Shared frame for the GitHub App redirect pages: the page header, then a
 * spinner row while the exchange or claim runs, or a danger alert naming
 * what failed with a link back to the workspace's Resources to start over.
 */
export function GitHubAppSetupView({ error }: { error: string | null }) {
  const wsId = useWorkspaceStore((s) => s.activeWorkspaceId)
  const wsName = useWorkspaceStore(
    (s) => s.workspaces.find((w) => w.workspace_id === wsId)?.name,
  )
  const resourcesUrl = wsId ? ROUTES.workspaceResources(wsId) : undefined
  const [startOverBefore, startOverAfter] =
    githubCopy.startOver.sentence.split('{link}')

  return (
    <WsPageShell
      title={githubCopy.title}
      crumbs={[
        {
          label: (wsName ?? githubCopy.crumbs.workspace).toLowerCase(),
          to: ROUTES.home,
        },
        { label: githubCopy.crumbs.resources, to: resourcesUrl },
        { label: githubCopy.crumbs.current },
      ]}
    >
      {error === null ? (
        <Inline gap="space-8" aria-busy="true">
          <Spinner />
        </Inline>
      ) : (
        <Alert tone="danger">
          <Stack gap="space-4">
            <Text as="p">{error}</Text>
            <Text as="p">
              {startOverBefore}
              {resourcesUrl ? (
                <Link href={resourcesUrl}>{githubCopy.startOver.link}</Link>
              ) : (
                githubCopy.startOver.link
              )}
              {startOverAfter}
            </Text>
          </Stack>
        </Alert>
      )}
    </WsPageShell>
  )
}
